import { FlexBox, SPACING, Typography, QuestSeries } from "@joonapp/web-shared"

import useQuestBoardDndFilters from "./hooks/useQuestBoardDndFilters"
import { useQuestDndSections } from "./hooks/useQuestDndSections"
import { useQuestDndSectionsStore } from "./hooks/useQuestDndSectionsStore"
import QuestDndCard from "./QuestDndCard"
import { MultipleSortableLists } from "../../../components/dnd/MultipleSortableLists"
import { SortableList } from "../../../components/dnd/SortableList"
import { QuestBoardSkeleton } from "../../../components/skeleton/Skeleton"

const QuestDndList = () => {
  const { isLoading: isLoadingReorderQuests } = useQuestBoardDndFilters()
  const { sections, setSections } = useQuestDndSectionsStore()
  useQuestDndSections()

  if (isLoadingReorderQuests) return <QuestBoardSkeleton />

  return (
    <FlexBox direction="column" gap={SPACING.space4}>
      <MultipleSortableLists
        sections={sections}
        onChange={setSections}
        renderItem={(questSeries) => <RenderedItem questSeries={questSeries} />}
        renderSection={(section: [string, QuestSeries[]]) => (
          <div className="flex flex-col gap-2 w-full" key={section[0]}>
            <Typography variant="bodySmallBold" className="capitalize">
              {section[0]}
            </Typography>
            <SortableList
              title={section[0]}
              items={section[1]}
              renderItem={(questSeries) => (
                <RenderedItem questSeries={questSeries} />
              )}
            />
          </div>
        )}
      />
    </FlexBox>
  )
}

const RenderedItem = ({ questSeries }: { questSeries: QuestSeries }) => {
  return (
    <SortableList.Item id={questSeries.id} handle={true}>
      <QuestDndCard questSeries={questSeries} />
    </SortableList.Item>
  )
}

export default QuestDndList
